import '@fontsource/roboto/700.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/300.css'
import '@fontsource/lora/400.css'

export const typography = {
  fonts: {
    body: 'Roboto',
    outstanding: 'Lora',
  },
}
